import { IVFSResponse } from '../types';
import BaseAPI from '../BaseAPI';
import { EmailData } from './types';

/**
 * Email API
 * Handles email-related operations
 */
class EmailAPI extends BaseAPI {
  /**
   * Send an email using Listmonk
   * @param emailData - Email data containing template, recipient, and content
   */
  async sendEmail(emailData: EmailData): Promise<IVFSResponse<void>> {
    return this.wrapResponse<void>({
      promise: this.apiInstance.post('/v2/mail/send', emailData),
      errorMessage: 'Failed to send email',
    });
  }
}

export default EmailAPI;
